import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import * as $ from 'jquery';

@Injectable()
export class AlertsUtilitiesAppService {
  private confirmButtonText: string;
  private cancelButtonText: string;
  public toastr: any;
  constructor(
  ) {
    this.confirmButtonText = 'Aceptar';
    this.cancelButtonText = 'Cancelar';
  }
  public _closefade() {
    $('html, body').removeClass('swal2-shown');
    $('.swal2-container').remove();
  }
  public sweetAl(message: string, typeAlert: any = 'warning', titleAlert: string = ''): Promise<any> {
    let theMessage;
    if (message.length === 0) {
      theMessage = 'Error';
    } else {
      theMessage = message;
    }
    const objSweetAl = {
      title: titleAlert,
      text: theMessage,
      type: typeAlert,
      width: '350px',
      confirmButtonColor: '#ec961f',
      confirmButtonText: this.confirmButtonText,
      allowOutsideClick: false,
      allowEscapeKey: false
    };

    return new Promise((resolve, reject) => {
      resolve(
        Swal.fire(objSweetAl).then(() => {
          this._closefade();
        })
      );
    });
  }
  public sweetAlConfirm(
    message: string,
    typeAlert: any = 'warning',
    titleAlert: string = '',
    html: any = '',
    confirmButtonText: string = 'Si',
    cancelButtonText: string = 'No',
    allowOutsideClick: boolean = false,
    allowEscapeKey: boolean = false
  ): Promise<any> {
    let theMessage;

    if (message.length == 0) {
      theMessage = 'Error';
    } else {
      theMessage = message;
    }

    const objSweetAl = {
      title: titleAlert,
      text: theMessage,
      type: typeAlert,
      width: '350px',
      allowOutsideClick: allowOutsideClick,
      allowEscapeKey: allowEscapeKey,
      showCancelButton: true,
      confirmButtonClass: 'success',
      cancelButtonClass: 'danger',
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      html: html
    };


    return new Promise((resolve, reject) => {
      Swal.fire(objSweetAl).then((data) => {
        this._closefade();
        if (!data.dismiss) {
          resolve(data);
        } else {
          reject(data);
        }
      });
    });
  }
  public sweetAlTextArea(
    message: string, typeAlert: any = '', titleAlert: string = '', input: any = '', inputPlaceholder: any = ''
  ): Promise<any> {
    const objSweetAl = {
      title: titleAlert,
      text: message,
      type: typeAlert,
      input: input,
      inputPlaceholder: inputPlaceholder,
      showCancelButton: true,
      width: '450px',
      confirmButtonColor: '#ec961f',
      confirmButtonText: this.confirmButtonText,
      cancelButtonText: this.cancelButtonText,
      allowOutsideClick: false,
      allowEscapeKey: false
    };

    return new Promise((resolve, reject) => {
      resolve(
        Swal.fire(objSweetAl).then((data) => {
          // this._closefade();
          return data;
        })
      );
    });
  }
}
